import { callApi } from "@/api/api-core";

export const fetchPassengerTypeList = function() {
    return callApi("POST", "v4/passengertypes/list", undefined, true);
};
